import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { createNrtOrder, getAllNrtProducts } from '../../../services/nrtService';
import { Toast, ToastContainer } from "react-bootstrap";


const CreateNRTOrder = ({ chatUserProfile, chatUserID, show, handleClose }) => {

    const [products, setProducts] = useState([]);
    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [showErrorToast, setShowErrorToast] = useState(false);


    useEffect(() => {
        const getProducts = async () => {
            try {
                const result = await getAllNrtProducts();
                setProducts(result || []);
            } catch (error) {
                console.error("Error fetching NRT products:", error);
            }
        };

        if (show) {
            getProducts();
        }
    }, [show]);


    const [newNrtOrder, setNewNrtOrder] = useState({
        clientId: chatUserID,
        productOrder1: "",
        productOrder1Quantity: 1,
        productOrder1VoucherCode: "",
        productOrder1IsSwapToStop: false,
        productOrder2: "",
        productOrder2Quantity: 1,
        productOrder2VoucherCode: "",
        productOrder2IsSwapToStop: false,
        showOrder2: false,
        products: [
            {
                id: "",
                voucherCode: "",
            }
        ],
        notes: ""
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        let newValue = type === "checkbox" ? checked : value;

        // Clamp productOrder1Quantity to 1 if it's not 1, 2, 3 or 4
        if (name === "productOrder1Quantity" || name === "productOrder2Quantity") {
            const numericValue = parseInt(value, 10);

            if (![1, 2, 3, 4].includes(numericValue)) {
                newValue = 1;
            } else {
                newValue = numericValue;
            }
        }

        setNewNrtOrder((prev) => ({
            ...prev,
            [name]: newValue,
        }));
    };

    const handleSave = async () => {
        // Create a new order object with the updated structure
        const product1Quantity = parseInt(newNrtOrder.productOrder1Quantity, 10) || 1;
        const product2Quantity = parseInt(newNrtOrder.productOrder2Quantity, 10) || 0;

        const product1Array = Array.from({ length: product1Quantity }, () => ({
            id: newNrtOrder.productOrder1 || "",
            voucherCode: newNrtOrder.productOrder1VoucherCode,
            isSwapToStop: newNrtOrder.productOrder1IsSwapToStop,
        }));

        const product2Array = newNrtOrder.showOrder2
            ? Array.from({ length: product2Quantity }, () => ({
                id: newNrtOrder.productOrder2 || "",
                voucherCode: newNrtOrder.productOrder2VoucherCode,
                isSwapToStop: newNrtOrder.productOrder2IsSwapToStop,
            }))
            : [];

        const formattedOrder = {
            clientId: chatUserID,
            notes: newNrtOrder.notes,
            products: [...product1Array, ...product2Array],
        };

        try {
            const createdOrder = await createNrtOrder(formattedOrder);
            setShowSuccessToast(true);

        } catch (error) {
            console.error("Error creating NRT order:", error);
            setShowErrorToast(true);
        }

        handleClose();
    };

    return (
        <>
            {show && (
                <Form>

                    <h3>NRT Products</h3>

                    <Form.Group className="mb-3">
                        <Form.Label>Product 1</Form.Label>
                        <Form.Control as="select" name="productOrder1" value={newNrtOrder.productOrder1} onChange={handleChange}>
                            <option value="">Select product</option>
                            {products
                                .filter(product => product.isInStock)
                                .map(product => (
                                    <option key={product.id} value={product.id}>
                                        {product.name}
                                    </option>
                                ))}

                        </Form.Control>

                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Product 1 Quantity</Form.Label>
                        <Form.Control
                            type="number"
                            name="productOrder1Quantity"
                            value={newNrtOrder.productOrder1Quantity}
                            onChange={handleChange}
                            min={1}
                            max={4}
                        />
                    </Form.Group>

                    {['e-cig', 'vape starter kit', 'vape refill'].includes(
                        products.find(p => p.id === newNrtOrder.productOrder1)?.name.toLowerCase()
                    ) && (
                            <Form.Group className="mb-3">
                                <Form.Label>Voucher Code</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="productOrder1VoucherCode"
                                    value={newNrtOrder.productOrder1VoucherCode}
                                    onChange={handleChange}
                                />

                                <Form.Label>Swap to Stop?</Form.Label>
                                <div>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        label="Yes"
                                    name="productOrder1IsSwapToStop"
                                    id="productOrder1IsSwapToStopYes"
                                        value="true"
                                    checked={newNrtOrder.productOrder1IsSwapToStop === true}
                                    onChange={() => handleChange({ target: { name: 'productOrder1IsSwapToStop', value: true } })}
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        label="No"
                                    name="productOrder1IsSwapToStop"
                                    id="productOrder1IsSwapToStopNo"
                                        value="false"
                                    checked={newNrtOrder.productOrder1IsSwapToStop === false}
                                    onChange={() => handleChange({ target: { name: 'productOrder1IsSwapToStop', value: false } })}
                                    />
                                </div>
                            </Form.Group>

                        )}

                    <Form.Group className="mb-3">
                        <Form.Check
                            type="checkbox"
                            label="Add a second product"
                            name="showOrder2"
                            checked={newNrtOrder.showOrder2}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    {newNrtOrder.showOrder2 && (
                        <>
                            <Form.Group className="mb-3">
                                <Form.Label>Product 2</Form.Label>
                                <Form.Control as="select" name="productOrder2" value={newNrtOrder.productOrder2} onChange={handleChange}>
                                    <option value="">Select product 2</option>
                                    {products
                                        .filter(product => product.isInStock)
                                        .map(product => (
                                            <option key={product.id} value={product.id}>{product.name}</option>
                                        ))}

                                </Form.Control>

                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Product 2 Quantity</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="productOrder2Quantity"
                                    value={newNrtOrder.productOrder2Quantity}
                                    onChange={handleChange}
                                    min={1}
                                    max={4}
                                />
                            </Form.Group>

                            {['e-cig', 'vape starter kit', 'vape refill'].includes(
                                products.find(p => p.id === newNrtOrder.productOrder2)?.name.toLowerCase()
                            ) && (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Voucher Code</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="productOrder2VoucherCode"
                                            value={newNrtOrder.productOrder2VoucherCode}
                                            onChange={handleChange}
                                        />


                                        <Form.Label>Swap to Stop?</Form.Label>
                                        <div>
                                            <Form.Check
                                                inline
                                                type="radio"
                                                label="Yes"
                                            name="productOrder2IsSwapToStop"
                                            id="productOrder2IsSwapToStopYes"
                                                value="true"
                                            checked={newNrtOrder.productOrder2IsSwapToStop === true}
                                            onChange={() => handleChange({ target: { name: 'productOrder2IsSwapToStop', value: true } })}
                                            />
                                            <Form.Check
                                                inline
                                                type="radio"
                                                label="No"
                                            name="productOrder2IsSwapToStop"
                                            id="productOrder2IsSwapToStopNo"
                                                value="false"
                                            checked={newNrtOrder.productOrder2IsSwapToStop === false}
                                            onChange={() => handleChange({ target: { name: 'productOrder2IsSwapToStop', value: false } })}
                                            />
                                        </div>
                                    </Form.Group>
                                )}

                        </>
                    )}


                    <Form.Group className="mb-3">
                        <Form.Label>Order Notes {newNrtOrder.showOrder2 && "(Required)"}</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="notes"
                            value={newNrtOrder.notes}
                            onChange={handleChange}
                            required={newNrtOrder.showOrder2}
                            rows={6}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 d-flex justify-content-around">
                        <Button variant="danger" onClick={handleClose}>Close</Button>
                        <Button variant="primary" onClick={handleSave}>Create Order</Button>
                    </Form.Group>
                </Form>
            )}

            <ToastContainer position="top-end" className="p-3">
                <Toast onClose={() => setShowSuccessToast(false)} show={showSuccessToast} delay={3000} autohide bg="success">
                    <Toast.Header>
                        <strong className="me-auto">Success</strong>
                    </Toast.Header>
                    <Toast.Body className="text-white">Order created successfully!</Toast.Body>
                </Toast>
            </ToastContainer>
            <ToastContainer position="top-end" className="p-3">
                <Toast onClose={() => setShowErrorToast(false)} show={showErrorToast} delay={3000} autohide bg="danger">
                    <Toast.Header>
                        <strong className="me-auto">Error</strong>
                    </Toast.Header>
                    <Toast.Body className="text-white">There was an error creating the order</Toast.Body>
                </Toast>
            </ToastContainer>

        </>
    );
};

export default CreateNRTOrder;
